
import React from "react";
import { Modal, TabPanel, Tabs } from "tea-component";
import SqlAddSource from "../../../Multidimensional/Analysis/components/HeaderData/SqlAddSource";
import { useDblIntl } from "@/pages/datalab/utils/utils";

interface SqlViewModalProps {
  visible: boolean;
  setVisible: Function;
  isFromEdit: boolean;
  dataTables: any[];
  closeCallBack: Function;
}
export default function SqlViewModal(props: SqlViewModalProps) {
  const { visible, setVisible, isFromEdit, dataTables = [], closeCallBack } = props || {};
  const { dblFormatMessage: dataFormatMessage, } = useDblIntl("sql_view");

  const tabs = [
    {
      id: 'sql',
      label: isFromEdit ? dataFormatMessage('edit_sql') : dataFormatMessage('add_sql'),
    },
  ];

  return <Modal
    disableCloseIcon={false}
    destroyOnClose={true}
    visible={visible}
    onClose={() => setVisible(false)}
    className={'add-Source dbl-add-source dbl-add-drag-source dbl-sql-view-modal'}
    size={'80%'}
  >
    <Tabs
      className="dbl-add-source-tab"
      defaultActiveId={'sql'}
      animated={false}
      ceiling
      tabs={tabs}
      onActive={() => { }}
    >
      <TabPanel id="sql">
        <SqlAddSource
          isFromEdit={isFromEdit}
          dataTables={dataTables}
          edit={true}
          close={() => {
            setVisible(false);
          }}
          updateCallback={() => {
            closeCallBack?.('update');
            setVisible(false);
          }}
          saveAsCallback={() => {
            closeCallBack?.('save as');
            setVisible(false);
          }}
        />
      </TabPanel>
    </Tabs>
  </Modal>;
};